document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.b2bLocationFinder');

  sections.forEach(function (root) {
    initB2BLocationFinder(root);
  });
});

function initB2BLocationFinder(root) {
  let searchMarker = null;
  let currentBounds = null;
  let selectedBrandValue = 'all';

  const config = {
    sectionId: root.dataset.sectionId || '',
    useTestData: root.dataset.useTestData === 'true',
    storefrontAccessToken: root.dataset.storefrontAccessToken || '',
    googleMapsApiKey: root.dataset.googleMapsApiKey || '',
    shopDomain: root.dataset.shopDomain || ''
  };

  const mapElement = root.querySelector('.b2bLocationFinder__Map');
  const mapContainer = root.querySelector('.b2bLocationFinder__MapContainer');
  const listElement = root.querySelector('.b2bLocationFinder__List');
  const statusElement = root.querySelector('.b2bLocationFinder__Status');
  const searchInput = root.querySelector('.b2bLocationFinder__Search');
  const brandButtonsWrapper = root.querySelector('.b2bLocationFinder__Brands');
  const brandButtons = brandButtonsWrapper
    ? Array.from(brandButtonsWrapper.querySelectorAll('button[data-value]'))
    : [];
  const testDataScript = root.querySelector('.b2bLocationFinder__TestData');

  if (!mapElement || !listElement || !statusElement || !searchInput || !brandButtonsWrapper) return;

  if (!config.storefrontAccessToken && !config.useTestData) {
    statusElement.textContent = 'Fehler: storefront_api_token fehlt in den Section Settings.';
    return;
  }

  if (!config.googleMapsApiKey) {
    statusElement.textContent = 'Fehler: google_maps_api_key fehlt in den Section Settings.';
    return;
  }

  let allItems = [];
  let map = null;
  let infoWindow = null;
  let markers = [];
  let currentSearchToken = 0;
  let posCardElements = new Map();
  let markerByKey = new Map();

  function scrollToResults() {
    const anchor = root.querySelector('#scroll-to-results-anchor');
    if (!anchor) return;

    anchor.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }


  function getTestData() {
    if (!testDataScript) return [];

    try {
      const parsed = JSON.parse(testDataScript.textContent);
      return parsed.map(function (item, index) {
        return {
          ...item,
          categories: parseCategories(item.categories),
          _index: index
        };
      });
    } catch (error) {
      console.error('Testdaten konnten nicht gelesen werden.', error);
      return [];
    }
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getField(fields, key) {
    return fields.find(function (field) {
      return field.key === key;
    }) || null;
  }

  function getFieldValue(fields, key) {
    const field = getField(fields, key);
    return field ? field.value : null;
  }

  function getReferencedNames(field) {
    if (!field || !field.references || !field.references.edges) return [];

    return field.references.edges
      .map(function (edge) {
        const refFields = edge.node && edge.node.fields;
        if (!refFields) return null;
        const nameField = refFields.find(function (f) { return f.key === 'name'; });
        return nameField ? nameField.value : null;
      })
      .filter(Boolean);
  }

  function getPosKey(pos) {
    if (pos.id) return String(pos.id);
    if (pos.handle) return String(pos.handle);
    return String(pos._index);
  }

  function normalizeCategoryName(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseCategories(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value
        .map(function (item) {
          return String(item).trim();
        })
        .filter(Boolean);
    }

  return String(value)
    .split(',')
    .map(function (item) {
      return item.trim();
    })
    .filter(Boolean);
}

  function getSelectedBrandValue() {
    return selectedBrandValue;
  }

  function setActiveBrandButton(value) {
    selectedBrandValue = String(value || 'all').trim() || 'all';

    brandButtons.forEach(function (button) {
      const isActive = String(button.dataset.value || '').trim() === selectedBrandValue;

      button.classList.toggle('outline', !isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function itemHasBrand(item, brandValue) {
    const normalizedNeedle = normalizeCategoryName(brandValue);
    return parseCategories(item.categories).some(function (category) {
      return normalizeCategoryName(category) === normalizedNeedle;
    });
  }

  function filterByBrand(items, brandValue) {
    const value = String(brandValue || '').trim();

    if (!value || value === 'all') {
      return items.slice();
    }

    return items.filter(function (item) {
      return itemHasBrand(item, value);
    });
  }

  function toRadians(value) {
    return value * Math.PI / 180;
  }

  function distanceInKm(lat1, lng1, lat2, lng2) {
    const earthRadiusKm = 6371;
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return earthRadiusKm * c;
  }

  function debounce(fn, delay) {
    let timeoutId;
    return function () {
      const args = arguments;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  async function loadGoogleMaps() {
    if (window.google && window.google.maps) return;

    await new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[data-google-maps-loader="true"]');

      if (existing) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(config.googleMapsApiKey);
      script.async = true;
      script.defer = true;
      script.dataset.googleMapsLoader = 'true';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async function fetchAllPos() {
    const endpoint = 'https://' + config.shopDomain + '/api/2026-04/graphql.json';

    const query = `
      query B2BPosMap($after: String) {
        metaobjects(type: "etx_b2b_pos", first: 250, after: $after) {
          edges {
            cursor
            node {
              id
              handle
              fields {
                key
                type
                value
                references(first: 20) {
                  edges {
                    node {
                      ... on Metaobject {
                        id
                        fields {
                          key
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;

    let all = [];
    let after = null;
    let hasNextPage = true;

    while (hasNextPage) {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
        },
        body: JSON.stringify({
          query: query,
          variables: { after: after }
        })
      });

      if (!response.ok) {
        throw new Error('Storefront API HTTP ' + response.status);
      }

      const json = await response.json();

      if (json.errors) {
        throw new Error(JSON.stringify(json.errors));
      }

      const connection = json && json.data && json.data.metaobjects;

      if (!connection) {
        throw new Error('Keine metaobjects in der API-Antwort gefunden.');
      }

      const pageItems = connection.edges.map(function (edge, index) {
        const node = edge.node;
        const fields = node.fields || [];
        const lat = parseFloat(getFieldValue(fields, 'coordinates_lat'));
        const lng = parseFloat(getFieldValue(fields, 'coordinates_lng'));

        // Kategorienamen aus den aufgelösten Referenzen lesen
        const discountCategoriesField = getField(fields, 'discount_categories');
        const categories = getReferencedNames(discountCategoriesField);

        return {
          id: node.id,
          handle: node.handle,
          _index: all.length + index,
          name: getFieldValue(fields, 'name') || '',
          street_nr: getFieldValue(fields, 'street_nr') || '',
          zip: getFieldValue(fields, 'zip') || '',
          city: getFieldValue(fields, 'city') || '',
          contact_email: getFieldValue(fields, 'contact_email') || '',
          contact_phone: getFieldValue(fields, 'contact_phone') || '',
          categories: categories,
          coordinates_lat: lat,
          coordinates_lng: lng
        };
      });

      all = all.concat(pageItems);
      hasNextPage = connection.pageInfo.hasNextPage;
      after = connection.pageInfo.endCursor;
    }

    return all.filter(function (item) {
      return Number.isFinite(item.coordinates_lat) && Number.isFinite(item.coordinates_lng);
    });
  }

  async function geocodePlaceInSwitzerland(query) {
    if (!window.google || !google.maps || !google.maps.Geocoder) {
      throw new Error('Google Geocoder ist nicht verfügbar.');
    }

    const geocoder = new google.maps.Geocoder();

    return new Promise(function (resolve, reject) {
      geocoder.geocode(
        {
          address: String(query).trim(),
          componentRestrictions: {
            country: 'CH'
          }
        },
        function (results, status) {
          if (status !== 'OK' || !results || !results.length) {
            reject(new Error('Ort oder PLZ konnte nicht geocodiert werden.'));
            return;
          }

          const location = results[0].geometry.location;

          resolve({
            lat: location.lat(),
            lng: location.lng()
          });
        }
      );
    });
  }

  function ensureMap() {
    if (map) return;

    map = new google.maps.Map(mapElement, {
      center: { lat: 47.3769, lng: 8.5417 },
      zoom: 7,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    infoWindow = new google.maps.InfoWindow();

    map.addListener('click', function () {
      infoWindow.close();
    });
  }

  function clearMarkers() {
    markers.forEach(function (marker) {
      marker.setMap(null);
    });
    markers = [];
    markerByKey = new Map();
  }

  function clearSearchMarker() {
    if (searchMarker) {
      searchMarker.setMap(null);
      searchMarker = null;
    }
  }

  function openInfoWindowForMarker(marker) {
    if (!marker || !marker.posData) return;

    const pos = marker.posData;

    infoWindow.setContent(`
      <div class="background-color-black" style="max-width:100vw;width:max-content;padding:12px;font-size:1rem;">
        <div class="etx-text Text">
          <p>
            <strong style="font-size:1.2rem; margin-bottom: 10px;display: inline-block;">${escapeHtml(pos.name)}</strong><br>
            ${escapeHtml(pos.street_nr)}<br>
            ${escapeHtml(pos.zip)} ${escapeHtml(pos.city)}<br>
            <strong style="margin-top: 10px;display: inline-block;"><a style="box-shadow:none;outline:none;text-decoration:none;" href="tel:${escapeHtml(pos.contact_phone)}">${escapeHtml(pos.contact_phone)}</a></strong><br>
            <strong><a style="box-shadow:none;outline:none;text-decoration:none;" href="mailto:${escapeHtml(pos.contact_email)}">${escapeHtml(pos.contact_email)}</a></strong><br>
            <span style="margin-top: 10px;display: inline-block;">${escapeHtml(parseCategories(pos.categories).join(', '))}</span><br>
            ${typeof pos.distance_km === 'number' ? '<span style="margin-top: 10px;display: inline-block;">Distanz: ' + escapeHtml(pos.distance_km.toFixed(1)) + ' km</span>' : ''}
          </p>
        </div>
      </div>
    `);

    infoWindow.open(map, marker);
  }

  function openPosOnMap(posKey) {
    scrollToResults();

    if (!map) return;

    const marker = markerByKey.get(posKey);
    if (!marker) return;

    const position = marker.getPosition();
    if (!position) return;

    window.setTimeout(function () {
      map.panTo(position);

      const currentZoom = typeof map.getZoom === 'function' ? map.getZoom() : 7;
      map.setZoom(Math.max(currentZoom, 12));

      openInfoWindowForMarker(marker);
    }, 350);
  }

  function renderPosList(items) {
    listElement.innerHTML = '';
    posCardElements = new Map();

    const header = document.createElement('div');
    header.className = 'etx-flex__item c-12';
    header.id = 'b2b-pos-list-header-' + config.sectionId;
    header.innerHTML = '<p>Anzahl Händler: ' + items.length + '</p>';
    listElement.appendChild(header);

    items.forEach(function (pos) {
      const key = getPosKey(pos);
      const categories = parseCategories(pos.categories);

      const categoriesHtml = categories.length
        ? categories.map(function (category) {
            return `
              <button class="etx-button Button outline" data-value="${escapeHtml(category)}" aria-pressed="false" type="button">
                ${escapeHtml(category)}
              </button>
            `;
          }).join('')
        : '<p>Keine</p>';

      const item = document.createElement('div');
      item.className = 'etx-flex__item c-12 mob-m:c-6 tab-m:c-4 desk-s:c-3';
      item.dataset.posId = key;

      item.innerHTML = `
        <div class="etx-card Card ph-50 pb-25 background-color-black will-appear move-up">
          <a
            class="etx-card__link Card__link"
            href="#b2b-pos-map-${config.sectionId}"
            title="Händler '${escapeHtml(pos.name)}' anzeigen"
            aria-label="Händler '${escapeHtml(pos.name)}' anzeigen"
          ></a>

          <div class="etx-card__item Card__item pb-25">
            <div class="etx-text Text">
              <p class="font-size-large font-weight-bold">${escapeHtml(pos.name)}</p>
              <p>${escapeHtml(pos.street_nr)}</p>
              <p>${escapeHtml(pos.zip)} ${escapeHtml(pos.city)}</p>
            </div>
          </div>

          <div class="etx-card__item Card__item pv-25">
            <div class="etx-text Text">
              <p>
                <a class="font-weight-regular" title="${escapeHtml(pos.name)} anrufen" href="tel:${escapeHtml(pos.contact_phone)}">
                  ${escapeHtml(pos.contact_phone)}
                </a>
              </p>
              <p>
                <a class="font-weight-regular"  title="Mail an ${escapeHtml(pos.name)}" href="mailto:${escapeHtml(pos.contact_email)}">
                  ${escapeHtml(pos.contact_email)}
                </a>
              </p>
            </div>
          </div>

          <div class="etx-card__item Card__item pt-25 pb-100">
            <div class="etx-text Text">
              <div class="etx-button-list ButtonList">
                ${categoriesHtml}
              </div>
            </div>
          </div>

          <div class="etx-card__item Card__item pt-0 pb-100 b2b-pos-distance" style="display:none;">
            <div class="etx-text Text">
              <p></p>
            </div>
          </div>
        </div>
      `;

      const link = item.querySelector('.Card__link');
      if (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          openPosOnMap(key);
        });
      }

      posCardElements.set(key, item);
      listElement.appendChild(item);
    });
  }

  function updateVisiblePosList(visibleItems, options) {
    const settings = options || {};
    const title = settings.title || 'Alle Händler';
    const showDistance = settings.showDistance || false;

    const header = root.querySelector('#b2b-pos-list-header-' + config.sectionId);
    if (header) {
      header.innerHTML = '<p class="font-size-large font-weight-medium">' + escapeHtml(title) + ':</p>';
    }


    const visibleKeys = new Set(
      visibleItems.map(function (pos) {
        return getPosKey(pos);
      })
    );

    posCardElements.forEach(function (element, key) {
      element.style.display = visibleKeys.has(key) ? '' : 'none';
    });

    visibleItems.forEach(function (pos) {
      const key = getPosKey(pos);
      const element = posCardElements.get(key);
      if (!element) return;

      const distanceEl = element.querySelector('.b2b-pos-distance');
      if (distanceEl) {
        if (showDistance && typeof pos.distance_km === 'number') {
          distanceEl.style.display = 'block';
          distanceEl.textContent = 'Distanz: ' + pos.distance_km.toFixed(1) + ' km';
        } else {
          distanceEl.style.display = 'none';
          distanceEl.textContent = '';
        }
      }

      listElement.appendChild(element);
    });
  }

  function renderMap(items, options) {
    const settings = options || {};
    const searchLocation = settings.searchLocation || null;

    ensureMap();
    clearMarkers();
    clearSearchMarker();

    const bounds = new google.maps.LatLngBounds();

    if (searchLocation) {
      searchMarker = new google.maps.Marker({
        map: map,
        position: searchLocation,
        title: 'Suchort',
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        }
      });

      bounds.extend(searchLocation);
    }

    items.forEach(function (pos) {
      const key = getPosKey(pos);

      const position = {
        lat: pos.coordinates_lat,
        lng: pos.coordinates_lng
      };

      const marker = new google.maps.Marker({
        map: map,
        position: position,
        title: pos.name
      });

      marker.posData = pos;

      marker.addListener('click', function () {
        openInfoWindowForMarker(marker);
      });

      markers.push(marker);
      markerByKey.set(key, marker);
      bounds.extend(position);
    });

    if (items.length === 0 && !searchLocation) {
      map.setCenter({ lat: 46.8182, lng: 8.2275 });
      map.setZoom(7);
      return;
    }

    if (items.length === 1 && !searchLocation) {
      map.setCenter(bounds.getCenter());
      map.setZoom(window.innerWidth < 768 ? 10 : 12);
      return;
    }

    const isMobile = window.innerWidth < 768;
    const fitBoundsPadding = isMobile ? 15 : 60;
    const minZoomAfterFit = isMobile ? 6 : 5;

    currentBounds = bounds;
    map.fitBounds(bounds, fitBoundsPadding);

    google.maps.event.addListenerOnce(map, 'idle', function () {
      if (map.getZoom() < minZoomAfterFit) {
        map.setZoom(minZoomAfterFit);
      }
    });
  }

  function filterByText(items, query) {
    const normalized = query.trim().toLowerCase();

    if (!normalized) {
      return items.slice();
    }

    return items.filter(function (item) {
      const haystack = [
        item.name,
        item.street_nr,
        item.zip,
        item.city,
        item.contact_email,
        item.contact_phone,
        Array.isArray(item.categories) ? item.categories.join(' ') : item.categories
      ].join(' ').toLowerCase();

      return haystack.includes(normalized);
    });
  }

  async function applyFilters(rawQuery) {
    const token = ++currentSearchToken;
    const query = String(rawQuery || '').trim();
    const selectedBrand = getSelectedBrandValue();

    try {
      statusElement.textContent = 'Suche läuft …';

      const brandFilteredItems = filterByBrand(allItems, selectedBrand);

      if (!query) {
        renderMap(brandFilteredItems);
        updateVisiblePosList(brandFilteredItems, {
          title: selectedBrand && selectedBrand !== 'all'
            ? 'Händler für Brand "' + selectedBrand + '"'
            : 'Alle Händler'
        });
        listElement.style.display = 'none';
        statusElement.textContent = brandFilteredItems.length ? '' : 'Keine Treffer gefunden.';
        scrollToResults();
        return;
      }

      let geocodedOrigin = null;

      try {
        geocodedOrigin = await geocodePlaceInSwitzerland(query);
      } catch (geocodeError) {
        geocodedOrigin = null;
      }

      if (token !== currentSearchToken) return;

      if (geocodedOrigin) {
        const nearest = brandFilteredItems
          .map(function (item) {
            return {
              ...item,
              distance_km: distanceInKm(
                geocodedOrigin.lat,
                geocodedOrigin.lng,
                item.coordinates_lat,
                item.coordinates_lng
              )
            };
          })
          .sort(function (a, b) {
            return a.distance_km - b.distance_km;
          })
          .slice(0, 8);

        renderMap(nearest, {
          searchLocation: geocodedOrigin
        });

        updateVisiblePosList(nearest, {
          title: 'Nächste 8 Händler zu "' + query + '"' + (selectedBrand && selectedBrand !== 'all' ? ' mit Brand "' + selectedBrand + '"' : ''),
          showDistance: true
        });

        if (nearest.length) {
          listElement.style.display = 'flex';
          listElement.classList.remove('will-appear');
          listElement.classList.add('did-appear');
          listElement.querySelectorAll('.will-appear').forEach(function (el) {
            el.classList.remove('will-appear');
            el.classList.add('did-appear');
          });

          
          mapContainer.style.display = 'block';
          mapContainer.classList.remove('will-appear');
          mapContainer.classList.add('did-appear');
          mapContainer.querySelectorAll('.will-appear').forEach(function (el) {
            el.classList.remove('will-appear');
            el.classList.add('did-appear');
          });
        } else {
          mapContainer.style.display = 'none';
          listElement.style.display = 'none';
        }
        scrollToResults();
        statusElement.textContent = nearest.length ? '' : 'Keine Händler im Umkreis gefunden.';
        return;
      }

      const textFiltered = filterByText(brandFilteredItems, query);

      if (token !== currentSearchToken) return;

      renderMap(textFiltered);
      updateVisiblePosList(textFiltered, {
        title: 'Suchresultate für "' + query + '"' + (selectedBrand && selectedBrand !== 'all' ? ' (' + selectedBrand + ')' : '')
      });

      listElement.style.display = 'none';
      mapContainer.style.display = 'none';
      scrollToResults();
      statusElement.textContent = textFiltered.length ? '' : 'Keine Treffer gefunden.';
    } catch (error) {
      console.error(error);
      if (token !== currentSearchToken) return;
      statusElement.textContent = 'Die Suche konnte nicht durchgeführt werden.';
    }
  }

  const debouncedApplyFilters = debounce(function () {
    applyFilters(searchInput.value);
  }, 500);

  async function init() {
    try {

      if (config.useTestData) {
        allItems = getTestData();
      } else {
        allItems = await fetchAllPos();
      }

      if (!allItems.length) {
        statusElement.textContent = 'Keine Händler mit gültigen Koordinaten gefunden.';
        return;
      }

      await loadGoogleMaps();

      setActiveBrandButton('all');
      renderMap(allItems);
      renderPosList(allItems);
      updateVisiblePosList(allItems, { title: 'Alle Händler' });
      statusElement.textContent = '';

      searchInput.addEventListener('input', function () {
        debouncedApplyFilters();
      });

      brandButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          const value = String(button.dataset.value || 'all').trim() || 'all';
          setActiveBrandButton(value);
          applyFilters(searchInput.value);
        });
      });

      window.addEventListener('resize', debounce(function () {
        if (!map || !currentBounds) return;

        const isMobile = window.innerWidth < 768;
        const padding = isMobile ? 15 : 60;
        const minZoomAfterFit = isMobile ? 6 : 5;

        map.fitBounds(currentBounds, padding);

        google.maps.event.addListenerOnce(map, 'idle', function () {
          if (map.getZoom() < minZoomAfterFit) {
            map.setZoom(minZoomAfterFit);
          }
        });
      }, 300));
    } catch (error) {
      console.error(error);
      statusElement.textContent = 'Fehler beim Laden der Händler oder der Karte.';
    }
  }

  init();
}